// 3rd Party
import PropTypes from 'prop-types';
import React from 'react';

// Components
import { Icon } from 'opencare-crown';
import {
  Div,
  FlexRow,
  OCBadge,
  TextSkeleton,
} from 'common/styles/oc-styled-components';

// Other
import { colors, NAV_HEIGHT } from 'common/styles/style-constants';
import scrollToRef from 'utils/scrollToRef';
import {
  getAggregateReviewData,
  reviewRatingMean,
} from 'pages/common/helpers/common-helpers';

import RatingMedium from '../../../common/components/RatingMedium/RatingMedium';
import ProfileImageCircles from '../../../common/components/ProfileImageCircles/ProfileImageCircles';
import {
  SuperPracticeBadge,
  SuperPracticeBadgeContainer,
} from '../../../results/components/ResultCard/styled-components';
import { SuperPracticeBadgeSVG } from '../../../../assets/icons';
import { ClinicSubRatingBadge } from '../../../common/components/ClinicSubRatingBadge/ClinicSubRatingBadge';

import { AddressLine, ProfileName } from './styled-components';

// Component
// TODO change globe icon?
const ProfileHeaderTablet = ({
  clinicId,
  hasInsurance,
  images,
  inNetwork,
  name,
  address,
  refToReviews,
  reviews,
  reviewsCount,
  isSuperPractice,
  isProspectLead,
  aggregateSubRatings,
}) => {
  const aggregateReviews = getAggregateReviewData({
    clinicId,
    opencareReviews: reviews,
  });

  return (
    <>
      <FlexRow margin="0 0 10px 0">
        {isSuperPractice 
          && (
            <SuperPracticeBadgeContainer size="large">
              <SuperPracticeBadge size="large">
                <SuperPracticeBadgeSVG color="#F37F6E" />
              </SuperPracticeBadge>
              <span>Super Practice</span>
            </SuperPracticeBadgeContainer>
          )
        }
        <FlexRow
          margin="0 0 0 auto"
          align="center"
          flexWrap="wrap"
          style={{ gap: '8px', rowGap: '8px' }}
        >
          {hasInsurance
            && (inNetwork
              ?               (
                <OCBadge color={colors.sageDark} width="130px">
                  <Icon type="login" />
                  In-Network
                </OCBadge>
              )
              :               (
                <>
                  {!isProspectLead 
                    && (
                      <OCBadge color={colors.darkBlue} width="130px">
                        <Icon type="logout" />
                        Out-of-network
                      </OCBadge>
                    )
                  }
                </>
              )
            )}
        </FlexRow>
      </FlexRow>
      <FlexRow>
        <Div width="60%">
          <TextSkeleton
            active
            loading={!name}
            margin="5px 0 2px 0"
            paragraph={false}
            title
          >
            <ProfileName>{name}</ProfileName>
          </TextSkeleton>
          <TextSkeleton
            active
            loading={!address}
            margin="5px 0 2px 0"
            paragraph={false}
            title
          >
            <AddressLine margin="0 0 0 0">
              {address.street_number} {address.route}
              {address.suite ? `, ${address.suite}` : ''}
            </AddressLine>
            <AddressLine margin="0 0 10px 0">
              {address.locality}, {address.administrative_area_level_1_short}{' '}
              {address.postal_code}
            </AddressLine>
          </TextSkeleton>
          <Div
            cursor="pointer"
            onClick={() => scrollToRef(refToReviews, NAV_HEIGHT + 10)}
            width="165px"
          >
            <div id="optimizely-ar-rating-block-original">
              <RatingMedium
                averageRating={reviewRatingMean(reviews)}
                reviewsCount={reviewsCount}
              />
            </div>
            <Div
              display="none"
              width="max-content"
              id="optimizely-ar-rating-block-experiment"
            >
              <RatingMedium
                sourcesCount={aggregateReviews.sources}
                averageRating={aggregateReviews.rating}
                reviewsCount={aggregateReviews.count}
                inlineRatingStars
              />
            </Div>
          </Div>
          <FlexRow margin="10px 0 0">
            <ClinicSubRatingBadge
              staffRating={aggregateSubRatings?.staff?.score}
              careQualityRating={aggregateSubRatings?.careQuality?.score}
              equipmentRating={aggregateSubRatings?.equipment?.score}
              height="30.85px"
            />
          </FlexRow>
        </Div>
        <FlexRow margin="0 0 0 auto">
          <ProfileImageCircles
            border={`3px solid ${colors.white}`}
            boxShadow="0 1px 2px rgba(0,0,0,.15)"
            height="100px"
            images={images}
            marginRight="-35px"
            width="100px"
          />
        </FlexRow>
      </FlexRow>
    </>
  );
};

ProfileHeaderTablet.propTypes = {
  clinicId: PropTypes.number.isRequired,
  hasInsurance: PropTypes.bool,
  images: PropTypes.array,
  inNetwork: PropTypes.bool,
  name: PropTypes.string,
  address: PropTypes.object,
  refToReviews: PropTypes.object,
  reviews: PropTypes.array,
  reviewsCount: PropTypes.number,
  isSuperPractice: PropTypes.bool,
  isProspectLead: PropTypes.bool,
  aggregateSubRatings: PropTypes.object,
};

export default ProfileHeaderTablet;
